import * as types from '../../actionsTypes/algolia/algoliaCityTypes'

const initialState = {
	search: '',
	arrayListToDropdown: [],
	isLoading: false
}

const algoliaCityReducer = (state = initialState, { type, payload }) => {
	switch (type) {
		case types.SEARCH_CITY:
			return {
				...state,
				search: payload
			}
		
		case types.ARRAY_LIST_TO_DROPDOWN_ALGOLIA_CITY:
			return {
				...state,
				arrayListToDropdown: payload
			}
		
		case types.IS_LOADING_ALGOLIA_CITY:
			return {
				...state,
				isLoading: payload
			}
		
		default:
			return state
	}
}

export default algoliaCityReducer
